import { render, staticRenderFns } from "./PainelChamadosFechadosAgetic.vue?vue&type=template&id=68188ced"
import script from "./PainelChamadosFechadosAgetic.vue?vue&type=script&lang=js"
export * from "./PainelChamadosFechadosAgetic.vue?vue&type=script&lang=js"
import style0 from "./PainelChamadosFechadosAgetic.vue?vue&type=style&index=0&id=68188ced&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports